/* eslint-disable react/prop-types */
import React from 'react';
import styles from './roundphoto.module.css';

const RoundPhoto = ({ src, alt, size, borderEnable }) => {
    const customSize = size || '2.90rem';
    const border = '2px solid #808080';
    const customStyle = {
        width: customSize,
        height: customSize,
        border: borderEnable ? border : 'none'
    };
    return (
        <div className={styles.photo__container} style={customStyle}>
            <img src={src} alt={alt} className={styles.photo} />
        </div>
    );
};

export default RoundPhoto;
